"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Item", {
  enumerable: true,
  get: function () {
    return _Item.default;
  }
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Item = _interopRequireDefault(require("./Item"));
var _styles = _interopRequireDefault(require("./styles"));
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const List = /*#__PURE__*/_react.default.forwardRef(({
  darkTheme,
  padding,
  linksAlternate,
  ...props
}, ref) => {
  const Tag = props.ordered || props.numbers || props.numbersHighlighted ? 'ol' : 'ul';
  const role = props?.role ? props.role : props.selectList ? 'listbox' : 'list';
  return (0, _jsxRuntime.jsx)(Tag, {
    role: role,
    css: theme => [_styles.default.default(theme), props.ordered && _styles.default.ordered, props.links && _styles.default.links(theme), props.points && _styles.default.points(theme), props.numbers && _styles.default.numbers, props.numbersHighlighted && _styles.default.numbersHighlighted(theme), props.selectList && _styles.default.selectList(theme), props.nostyle && _styles.default.nostyle, props.rowHeight && _styles.default.rowHeight(props.rowHeight), props.minRowHeight && _styles.default.minRowHeight(props.minRowHeight), darkTheme && _styles.default.darkTheme(theme), padding && _styles.default.setPadding(padding), linksAlternate && _styles.default.linksAlternate(theme)],
    ref: ref,
    children: _react.default.Children.map(props.children, child => {
      if (!child) {
        return null;
      }
      return child;
    })
  });
});
var _default = exports.default = List;